import { defaultBaseQuery, transformErrorResponse, transformSuccessResponse } from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const studentAttendanceAPI = createApi({
    reducerPath: "studentAttendanceAPI",
    baseQuery: defaultBaseQuery,
    tagTypes: ["StudentAttendanceReport", "StudentAttendanceRegister"],
    endpoints: (builder) => ({
        // GET /s-lams/attendance/student?fromDate=YYYY-MM-DD&toDate=YYYY-MM-DD
        getStudentAttendanceReport: builder.query({
            query: ({ fromDate, toDate, programId, courseId, semesterYearId, admissionSystem, page = 0, size = 10, searchText, sortBy, sortDir } = {}) => ({
                url: `/attendance/student`,
                method: "GET",
                params: { fromDate, toDate, programId, courseId, semesterYearId, admissionSystem, page, size, searchText, sortBy, sortDir },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["StudentAttendanceReport"],
        }),
        // GET /s-lams/attendance/register
        getStudentAttendanceRegister: builder.query({
            query: ({ currentDate, programId, courseId, semesterYearId, admissionSystem, page = 0, size = 10, searchText, sortBy, sortDir } = {}) => ({
                url: `/attendance/register`,
                method: "GET",
                params: { currentDate, programId, courseId, semesterYearId, admissionSystem, page, size, searchText, sortBy, sortDir },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["StudentAttendanceRegister"],
        }),
        // GET /s-lams/attendance/student/excel
        exportStudentAttendanceReportExcel: builder.query({
            query: ({ fromDate, toDate, programId, courseId, semesterYearId, admissionSystem, page = 0, size = 10, searchText, sortBy, sortDir } = {}) => ({
                url: `/attendance/student/excel`,
                method: "GET",
                params: { fromDate, toDate, programId, courseId, semesterYearId, admissionSystem, page, size, searchText, sortBy, sortDir },
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `student_attendance_report_${fromDate}_${toDate}.xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    return { success: true };
                },
                cache: 'no-cache',
            }),
            transformErrorResponse: transformErrorResponse,
        }),
        // GET /s-lams/attendance/register/excel
        exportStudentAttendanceRegisterExcel: builder.query({
            query: ({ currentDate, programId, courseId, semesterYearId, admissionSystem, page = 0, size = 10, searchText, sortBy, sortDir } = {}) => ({
                url: `/attendance/register/excel`,
                method: "GET",
                params: { currentDate, programId, courseId, semesterYearId, admissionSystem, page, size, searchText, sortBy, sortDir },
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `student_attendance_register_${currentDate}.xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    return { success: true };
                },
                cache: 'no-cache',
            }),
            transformErrorResponse: transformErrorResponse,
        }),
        // POST /s-lams/attendance
        addStudentAttendance: builder.mutation({
            query: ({ date, mobilePunch, uskId, time, type }) => ({
                url: `/attendance`,
                method: "POST",
                body: { date, mobilePunch, uskId, time, type },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ["StudentAttendanceRegister"],
        }),
    }),
});

export const {
    useLazyGetStudentAttendanceReportQuery,
    useLazyGetStudentAttendanceRegisterQuery,
    useLazyExportStudentAttendanceReportExcelQuery,
    useLazyExportStudentAttendanceRegisterExcelQuery,
    useAddStudentAttendanceMutation,
} = studentAttendanceAPI;

export default studentAttendanceAPI;
